import { createContext, useCallback, useContext, useMemo, useState } from 'react';
import Cookies from 'js-cookie';

const ShiftContext = createContext();

/**
 * Стан відкритої зміни.
 *
 * Кука ShiftId — це лише локальний кеш; джерело правди — бекенд
 * (kasa_shifts/get_current_shift_simplified_data/), який перевіряється
 * перед кожною грошовою операцією через useValidateShift.
 */
export const ShiftProvider = ({ children }) => {
    const [shiftId, setShiftId] = useState(() => Cookies.get('ShiftId') ?? null);

    const openShift = useCallback((id) => {
        if (id === undefined || id === null || id === '') {
            console.error('openShift: отримано некоректний ідентифікатор зміни', id);
            return;
        }

        const value = String(id);
        Cookies.set('ShiftId', value, { sameSite: 'strict' });
        setShiftId(value);
    }, []);

    const closeShift = useCallback(() => {
        Cookies.remove('ShiftId');
        setShiftId(null);
    }, []);

    // useCallback + useMemo тримають посилання стабільними — інакше
    // кожен рендер провайдера перезапускав useEffect у дочірніх екранах.
    const value = useMemo(
        () => ({ shiftId, isShiftOpen: shiftId !== null, openShift, closeShift }),
        [shiftId, openShift, closeShift]
    );

    return <ShiftContext.Provider value={value}>{children}</ShiftContext.Provider>;
};

export const useShift = () => useContext(ShiftContext);
